import { Dialog, Transition } from "@headlessui/react"
import { Fragment, useState } from "react"
import { X } from "react-feather"
import styles from "./WysiwygDialog.module.scss"
import cx from "classnames"

const WysiwygDialog = ({ label, content, buttonClassName }) => {
  let [isOpen, setIsOpen] = useState(false)

  if (!label || !content) return null

  return (
    <div className={styles.wysiwygDialog}>
      <button
        className={buttonClassName}
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
      >
        {label}
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog className="relative z-[1000]" onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-4xl transform overflow-hidden rounded-[32px] rounded-tl-none bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title className="flex justify-end">
                    <button type="button" onClick={() => setIsOpen(false)}>
                      <X className="text-gray-700" />
                    </button>
                  </Dialog.Title>

                  <div
                    className={cx(styles.wysiwyg, "wysiwygDialog")}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}

export default WysiwygDialog
